<template>
  <div class="searchAreaStyle d-flex align-center">
    <div v-if="isEdit" class="pl-16">
      {{ target }}
    </div>
    <span v-else class="d-flex align-center">
      <div class="yCenter original-selectbox selectBoxStyle pl-10 mr-2">
        <div class="titleStyle font-weight-bold pr-5">
          {{ $t('ship.ship_ship-storage') }}
        </div>
        <div class="combobox">
          <NormalCombobox
            v-model="selectClientName.ship"
            :items="selectBoxInfo.clientNameList"
            height="32px"
          />
        </div>

        <div class="titleStyle font-weight-bold pr-5 pl-10">
          {{ $t('loading.loading_loading-storage') }}
        </div>
        <div class="combobox">
          <NormalCombobox
            v-model="selectClientName.loading"
            :items="selectBoxInfo.clientNameList"
            height="32px"
          />
        </div>
      </div>

      <NormalButton
        :text="$t('sale.sale_select-pecipient-button')"
        height="32px"
        width="120px"
        color="white"
        textColor="thinText--text"
        :outlined="true"
        @click="recipientSearch"
      />
      <StorageRecipientSearchDialog
        v-model="dialog.recipientSearch"
        :selectClientName="selectClientName.loading"
        :target="selectBoxInfo.target.common"
        :comboboxList="selectBoxInfo.clientNameList"
        :tableData="history"
        @reflect="reflect"
      />

      <NormalTextButton
        v-if="authority.isAdmin || authority.isUser"
        :text="'＋' + $t('product.product_storage-register')"
        class="textButtonStyle"
        @click="dialogInfo.register = true"
      />
      <MasterStorageDialog
        v-model="dialogInfo.register"
        @success="registerSuccess"
      />
    </span>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { storageUtil } from '@/util'
import {
  NormalButton,
  NormalTextButton,
  NormalCombobox
} from '@/components/items'

import StorageRecipientSearchDialog from '@/components/layouts/Dialogs/StorageRecipientSearchDialog'
import { MasterStorageDialog } from '@/components/layouts/Dialogs'

export default {
  components: {
    NormalButton,
    NormalTextButton,
    NormalCombobox,
    StorageRecipientSearchDialog,
    MasterStorageDialog
  },
  props: {
    target: { default: '' }
  },
  data: () => ({
    isEdit: false,
    dialogInfo: {
      register: false
    },

    selectClientName: {
      ship: {
        label: '',
        value: null
      },
      loading: {
        label: '',
        value: null
      }
    },
    historySelectData: {
      selectClientName: {
        label: '',
        value: null
      },
      radioGroup: ''
    },
    selectBoxInfo: {
      target: {
        ship: 'ship.ship_ship',
        loading: 'loading.loading_loading',
        common: 'common.common_storage'
      },
      clientId: 'storageRecipientId',
      clientNameList: []
    },
    history: {
      headers: [
        {
          value: 'radioBtn',
          width: '55px',
          filterable: false,
          sortable: false,
          align: 'center'
        },
        {
          value: 'storageRecipientId',
          align: ' d-none'
        },
        {
          text: 'product.product_recipient-name',
          value: 'name',
          width: '109px',
          filterable: false,
          sortable: false,
          align: 'center'
        },
        {
          text: 'product.product_recipient-address',
          value: 'address',
          width: '249px',
          filterable: false,
          sortable: false,
          align: 'center'
        },
        {
          text: 'product.product_recipient-tel',
          value: 'phoneNumber',
          width: '159px',
          filterable: false,
          sortable: false,
          align: 'center'
        },
        {
          text: 'product.product_recipient-memo',
          value: 'note',
          width: '224px',
          filterable: false,
          sortable: false,
          align: 'center'
        }
      ],
      itemKey: 'storageRecipientId',
      items: []
    },
    dialog: {
      recipientSearch: false
    }
  }),
  async created() {
    await this.init(false)
  },

  methods: {
    ...mapActions('Storage', ['getStorageListFromApi']),
    ...mapGetters('Storage', ['getStorageListFromState']),

    registerSuccess() {
      this.init()
      this.dialogInfo.register = false
    },

    async init() {
      const isHideUnusedStorage = true
      const storageList = await storageUtil.getStorageIdNameList(
        isHideUnusedStorage
      )
      this.selectBoxInfo.clientNameList = storageList.data
    },

    async recipientSearch() {
      const target = this.selectBoxInfo.target
      if (!this.selectClientName.loading.value) {
        alert(
          this.$t(target.loading) +
            this.$t(target.common) +
            this.$t('common.common_input-select')
        )
        return
      }

      await Promise.all([this.getStorageListFromApi()]).then((message) => {
        const targetStorage = this.getStorageListFromState().find(
          (ele) => ele.storageId === this.selectClientName.loading.value
        )

        this.history.items = targetStorage.storageRecipients
        this.dialog.recipientSearch = true
      })
    },

    reflect(...args) {
      const [radioGroup] = args
      const storageRecipient = this.history.items.find(
        (ele) => ele[this.history.itemKey] === radioGroup
      )
      this.$emit('selectStorageRecipient', storageRecipient)
    }
  },
  computed: {
    ...mapGetters('User', ['authority'])
  },
  watch: {
    selectClientName: {
      deep: true,
      handler(newVal, oldVal) {
        this.$emit('change', newVal)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.searchAreaStyle {
  height: 70px;

  .titleStyle {
    font-size: 18px;
  }

  .combobox {
    width: 194px;
  }

  .selectBoxStyle {
    width: 670px;
    // margin: 0px 16px 0px 63px !important;
  }

  .textButtonStyle {
    margin: 0px 21px;
  }
}
</style>
